import React from 'react'
import PropTypes from 'prop-types'
import FormElementOption from './FormElementOption'

const Option = (props) => {
    const {
        id,
        value,
        text,
        type,
        onChange,
        selected,
        description,
    } = props

    return (
        <FormElementOption
            type={type}
            selected={selected}
            {...props}
        >
            {({ name, ...props }) => (
                <>
                    <input
                        id={id}
                        name={name}
                        type={type}
                        value={value}
                        checked={selected}
                        onChange={onChange}
                    />
                    <label className="form-label" htmlFor={id}>{text}</label>
                    {description && (
                        typeof description === 'string' ? (
                            <p className="form-element--option__description">
                                {description}
                            </p>
                        ) : (
                            description
                        )
                    )}
                </>
            )}
        </FormElementOption>
    )
}

Option.propTypes = {
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    text: PropTypes.node.isRequired,
    id: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    description: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}

export default Option
